import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { timeout } from 'rxjs';

const DEFAULT_TIMEOUT_MS = 30000;

export function timeoutInterceptorFn(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  return next(req).pipe(timeout(DEFAULT_TIMEOUT_MS));
}
